<template>
  <v-container fluid>
    <section id="print" style="font-family: Roboto,sans-serif">
      <div class="row">
        <div class="column">
          <img
            class="img"
            alt="Forge Nano"
            src="https://secureservercdn.net/50.62.175.49/i0f.de5.myftpupload.com/wp-content/uploads/2019/07/WebLogoNew.png?time=1570132201"
          />
        </div>
        <div class="column">
          <span>PACKING SLIP</span>
        </div>
      </div>
      <hr />
      <div class="row">
        <div class="column">
          <div>
            <b>ATTN: {{ shipment.shipto }}</b>
            <br />
            {{ shipment.address }}
            <br />
            {{ shipment.phone }}
          </div>
        </div>
      </div>
      <hr />
      <div class="row">
        <div class="column">
          <br />
          <h3 v-if="shipment.children.length > 0">Coated Contents</h3>
          <table
            style="width:100%"
            class="tableStyle"
            v-if="shipment.children.length > 0"
          >
            <tr>
              <th>Batch #</th>
              <th>Quantity</th>
              <th>Notes</th>
            </tr>
            <tr v-for="item in shipment.children" :key="item.id">
              <td>
                {{ item.batch.forgeID }}
              </td>
              <td>{{ item.quantity }}</td>
              <td>{{ item.notes }}</td>
            </tr>
          </table>

          <br />
          <br />
          <h3 v-if="shipment.children_misc.length > 0">Additional Contents</h3>
          <table
            style="width:100%"
            class="tableStyle"
            v-if="shipment.children_misc.length > 0"
          >
            <tr>
              <th>Item</th>
              <th>Quantity</th>
              <th>Notes</th>
            </tr>
            <tr v-for="item in shipment.children_misc" :key="item.id">
              <td>
                {{ item.item }}
              </td>
              <td>{{ item.quantity }}</td>
              <td>{{ item.notes }}</td>
            </tr>
          </table>
        </div>
      </div>
      <div class="row">
        <div class="column">
          <br />
          <hr />
          <span class="center">
            Please contact Customer Service at 720-259-8579 with any questions
            or comments. Thank you for your business!
          </span>
        </div>
      </div>
    </section>
    <br />
    <v-btn @click="print">Print</v-btn>
  </v-container>
</template>

<script>
export default {
  name: "ShippingPrintable",
  props: {
    shipment: {
      type: Object,
      required: true,
      default: () => {}
    },
    id: {
      type: [Number, String],
      required: true
    }
  },
  methods: {
    print() {
      // Get HTML to print from element
      const prtHtml = document.getElementById("print").innerHTML;

      // Get all stylesheets HTML
      let stylesHtml = `
      .row {
        display: flex;
        margin: 5px;
        font-family: sans-serif;
      }

      .column {
        flex: 100%;
        font-family: sans-serif;
      }
      .img {
        max-width: 300px;
        max-height: 300px;
      }
      .tableStyle {
        border-collapse: collapse;
        width: 100%;
        font-family: sans-serif;
      }
      .tableStyle td,
      .tableStyle th {
        border: 1px solid #ddd;
        padding: 8px;
      }
      .tableStyle th {
        padding-top: 12px;
        padding-bottom: 12px;
        text-align: left;
      }
      .center {
        display: block;
        margin-left: auto;
        margin-right: auto;
        width: 85%;
        font-size: 0.75rem;
        font-family: sans-serif;
      }
      #print {
        font-family: sans-serif;
      }
      `;
      // for (const node of [
      //   ...document.querySelectorAll('link[rel="stylesheet"], style')
      // ]) {
      //   stylesHtml += node.outerHTML;
      // }

      // Open the print window
      const WinPrint = window.open(
        "",
        "",
        "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0"
      );

      WinPrint.document.write(`<!DOCTYPE html>
      <html>
        <head>
          <style>
            ${stylesHtml}
        </style>
        </head>
        <body>
          ${prtHtml}
        </body>
      </html>`);

      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();
    }
  }
};
</script>

<style scoped>
.row {
  display: flex;
  margin: 5px;
}

.column {
  flex: 100%;
}
.img {
  max-width: 300px;
  max-height: 300px;
}
.tableStyle {
  border-collapse: collapse;
  width: 100%;
}

.tableStyle td,
.tableStyle th {
  border: 1px solid #ddd;
  padding: 8px;
}

.tableStyle th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
}
.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 85%;
  font-size: 0.75rem;
}
#print {
  font-family: sans-serif;
}
</style>
